import classNames from 'classnames';
import type { Ref } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import type { Props as GameProps } from './Game';
import { Game } from './Game';

const Root = styled(Vertical)`
  &.roundedTop {
    & > *:first-child {
      border-top-right-radius: var(--double-unit);
      border-top-left-radius: var(--double-unit);
    }
  }

  & > *:last-child {
    border-bottom-right-radius: var(--double-unit);
    border-bottom-left-radius: var(--double-unit);
  }
`;

type Props = {
  games: GameProps['game'][];
  hideGameWeek?: boolean;
  roundedTop?: boolean;
  ref?: Ref<HTMLDivElement>;
};

export const Games = ({ games, hideGameWeek, roundedTop, ref }: Props) => {
  return (
    <Root ref={ref} className={classNames({ roundedTop })}>
      {games.map(game => (
        <Game key={game.id} hideGameWeek={hideGameWeek} game={game} />
      ))}
    </Root>
  );
};
